const tecAnalysisTypes = {
  AT: 0,
  Quote: 1
}

export default tecAnalysisTypes



// WEBPACK FOOTER //
// ./src/views/private/operational/pci/components/tecanalysis/tecanalysistypes.js